import {getDate, setLiveState} from "./tool";

export const getNumConf = function (start_time, end_time, count, status, statusText) {
    let start = getDate(start_time), end = getDate(end_time);
    let duration = Math.round((end.getTime() - start.getTime()) / (60 * 1000));
    return {
        day: start.pattern("yyyy-MM-dd"),
        start: start.pattern("HH:mm:ss"),
        a: duration,
        b: count,
        c: 0,
        d: count,
        status,
        statusText
    }
}

export const dealLive = function (live) {
    if(live.other_config) {
        try {
            const otherConfig = JSON.parse(live.other_config);
            for(let key in otherConfig) {
                live[key] = otherConfig[key];
            }
        } catch (e) {
            console.error(e);
        }
    }
    setLiveState(live);

}
